export default __webpack_public_path__ + "static/media/facebook.d9aa25a1.svg";